// extracted by mini-css-extract-plugin
export var questionBox = "_ai-0";